import { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const useQueryPaginationStateHooks = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);

    const initialPage = parseInt(queryParams.get('page') || '1');
    const initialPageGroup = parseInt(queryParams.get('pageGroup') || '0');
    const initialReorderStatus = parseInt(queryParams.get('reorderState') || '0');
    const [currentPage, setCurrentPage] = useState(initialPage);
    const [pageGroup, setPageGroup] = useState(initialPageGroup);
    const [reorderStatus, setReorderStatus] = useState(initialReorderStatus);

    const handlePageGroup = useCallback(
        (group: number, newPage: number) => {
            setPageGroup(group);

            const newQueryParams = new URLSearchParams(location.search);
            newQueryParams.set('pageGroup', group.toString());
            newQueryParams.set('page', newPage.toString());
            setCurrentPage(newPage);
            navigate({ search: newQueryParams.toString() });
        },
        [navigate, currentPage]
    );

    const setMultipleParams = useCallback(
        (params: Record<string, string | number>, page?: number, pageGroup?: number) => {
            console.log(pageGroup, 'pageGroup', page, 'page', params, 'params');
            const newQueryParams = new URLSearchParams(location.search);

            Object.entries(params).forEach(([key, value]) => {
                newQueryParams.set(key, String(value));
            });

            navigate({ search: newQueryParams.toString() });

            // 로컬 상태 동기화
            if (page) {
                setCurrentPage(page);
            }
            if (pageGroup || pageGroup === 0) {
                setPageGroup(pageGroup);
            }
        },
        [navigate]
    );

    useEffect(() => {
        const currentQueryParams = new URLSearchParams(location.search);
        const page = parseInt(currentQueryParams.get('page') || '1');
        const pageGroup = parseInt(currentQueryParams.get('pageGroup') || '0');
        const reorderState = parseInt(currentQueryParams.get('reorderState') || '0');
        setReorderStatus(reorderState);
        setCurrentPage(page);
        setPageGroup(pageGroup);
    }, [location.search]);

    return { currentPage, pageGroup, handlePageGroup, reorderStatus, queryParams, setReorderStatus, setPageGroup, setCurrentPage, setMultipleParams } as const;
};

export default useQueryPaginationStateHooks;
